import { memo, useCallback } from 'react'

import { Divider } from '@mui/material'
import { SmepWorkspace } from '@nativewaves/nw-cloud-sdk/smep'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { MenuItemCopyId, MenuItemDelete } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useWorkspaceDeleteMutation } from 'hooks/mutations/smep'

const RowActionsRaw = ({ row, onClose }: RowActionsProps<SmepWorkspace>) => {
  const { t } = useTranslation(['common', 'domain'])
  const { enqueueSnackbar } = useSnackbar()

  const { mutate: deleteSmepWorkspace } = useWorkspaceDeleteMutation()

  const handleDeleteSmepWorkspace = useCallback(() => {
    onClose()

    deleteSmepWorkspace(
      { workspaceId: row.original.id },
      {
        onSuccess: () =>
          enqueueSnackbar(t('domain:Workspace.nameDelete', { name: row.original.name }), { variant: 'success' }),
      },
    )
  }, [deleteSmepWorkspace, enqueueSnackbar, onClose, row.original.id, row.original.name, t])

  return (
    <>
      <MenuItemCopyId onSuccess={onClose} id={row.original.id} />
      <MenuItemCopyId
        staticLabel={t('domain:Workspace.copyRepositoryId')}
        onSuccess={onClose}
        id={row.original.contentRepositoryId}
      />
      <Divider sx={{ my: 1 }} component="li" />
      <MenuItemDelete onConfirm={handleDeleteSmepWorkspace} />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
